import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-fill",
  "use": "icon-close-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-close-fill\">\n<path id=\"icon-close-fill_形状\" d=\"M8,0.6C3.9,0.6,0.6,3.9,0.6,8s3.3,7.4,7.4,7.4s7.4-3.3,7.4-7.4S12.1,0.6,8,0.6z M11.3,10.4c0.3,0.3,0.3,0.7,0,1\n\tc-0.3,0.3-0.7,0.3-1,0L8,9l-2.4,2.4c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1L7,8L4.7,5.6c-0.3-0.3-0.3-0.7,0-1\n\tc0.3-0.3,0.7-0.3,1,0L8,7l2.4-2.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1L9,8L11.3,10.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol